import React, { Component } from "react";
import actions from "actions";
import { connect } from "react-redux";
import {
  clearAddToCalendarLinks,
  getAddToCalendarLinks,
} from "../../actions/webinars";

const { hideModal } = actions;

const linkToValue = {
  google_url: {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/480px-Google_%22G%22_logo.svg.png",
    alt: "google logo",
  },
  office365_url: {
    src: "https://mailmeteor.com/logos/assets/PNG/Microsoft_Office_Outlook_Logo_512px.png",
    alt: "office365 logo",
  },
  yahoo_url: {
    src: "https://cdn.freebiesupply.com/logos/large/2x/yahoo-icon-logo-png-transparent.png",
    alt: "yahoo logo",
  },
};

class AddToCalendarModal extends Component {
  componentDidMount() {
    this.props.getCalendarLinks({
      webinarId: this.props.contentProps.payload.webinarId,
    });
  }

  componentWillUnmount() {
    this.props.clearAddToCalendarLinks();
  }

  render() {
    const links = this.props.links;

    return (
      <div>
        <div style={{ fontSize: 24 }}>Add To Calendar</div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 20,
            justifyContent: "center",
            marginTop: 10,
          }}
        >
          {!!Object.keys(links).length &&
            Object.keys(links).map((key, idx) => (
              <a href={links[key]} key={idx} target="_blank">
                <img
                  style={{ width: 75, height: 75 }}
                  src={linkToValue[key].src}
                  alt={linkToValue[key].alt}
                />
              </a>
            ))}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    contentProps: state.modal.modalContentProps,
    links: state.webinars.calendarLinks,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    hideModal: () => dispatch(hideModal()),
    getCalendarLinks: (payload) => dispatch(getAddToCalendarLinks(payload)),
    clearAddToCalendarLinks: () => dispatch(clearAddToCalendarLinks()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddToCalendarModal);



// WEBPACK FOOTER //
// ./src/containers/AddToCalendarModal/index.jsx